module.exports = __webpack_public_path__ + "img/dot.png?c29bbbeba74a34dd91a86e7704dae32d";